import { render, staticRenderFns } from "./ReviewRow.vue?vue&type=template&id=037c9a5d&"
import script from "./ReviewRow.vue?vue&type=script&lang=js&"
export * from "./ReviewRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports